import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ApplicationConfig } from '../config/config';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class CookieHelper {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private applicationConfig: ApplicationConfig
  ) {}

  setCookies(cookieName: any, cookieValue: any) {
    if (isPlatformBrowser(this.platformId)) {
      const cookiesLife = new Date();
      cookiesLife.setTime(cookiesLife.getTime() + 365 * 24 * 60 * 60 * 1000);
      const expires = '; expires=' + cookiesLife.toUTCString();
      const cookieDomain = this.applicationConfig.get('APP_COOKIE_DOMAIN');
      const cookieDetails =
        cookieName + '=' + cookieValue + expires + cookieDomain;
      document.cookie = cookieDetails;
    }
  }

  setCookieName(
    cookieName: any,
    cookieValue: any,
    expireDays: number,
    keepSession: boolean
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const cookiesLife = new Date();
      if (expireDays > 0 || keepSession) {
        cookiesLife.setTime(
          cookiesLife.getTime() + expireDays * 24 * 60 * 60 * 1000
        );
      } else {
        cookiesLife.setTime(expireDays);
      }
      const expires = keepSession
        ? ''
        : '; expires=' + cookiesLife.toUTCString();
      const cookieDomain = this.applicationConfig.get('APP_COOKIE_DOMAIN');
      const cookieDetails =
        cookieName + '=' + cookieValue + expires + cookieDomain;
      document.cookie = cookieDetails;
    }
  }

  setCookieValue(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookies(cookieName: any) {
    if (isPlatformBrowser(this.platformId)) {
      const result = new RegExp(
        '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
      ).exec(document.cookie);
      if (
        cookieName === 'newFeedAdvisoriesCountNumber' ||
        cookieName === 'lastVisitedFeedAdvisories'
      ) {
        return result ? result[1] : null;
      } else {
        return result ? result[0].replace(/[.; ]+/g, '') : null;
      }
    }
  }

  getCookieValue(cookieName: any) {
    if (isPlatformBrowser(this.platformId)) {
      const result = new RegExp(
        '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
      ).exec(document.cookie);
      return result ? result[1] : null;
    }
  }

  getCountryCode() {
    const prefCookie = this.getCookies('prefUI');
    if (prefCookie) {
      if (prefCookie.length > 0) {
        let res = prefCookie.split('=');
        if (!res || !res.length || !res[1]) {
          return null;
        }
        res = res[1].split('-');
        if (!res || !res.length || !res[1]) {
          return null;
        }
        return res[1].toLowerCase();
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getlanguageCode() {
    const prefCookie = this.getCookies('prefUI');
    const defaultLang = 'en';
    if (prefCookie) {
      if (prefCookie.length > 0) {
        let res = prefCookie.split('=');
        if (!res || !res.length || !res[1]) {
          return defaultLang;
        }
        res = res[1].split('-');
        if (!res || !res.length || !res[0]) {
          return defaultLang;
        }
        return res[0].toLowerCase();
      } else {
        return defaultLang;
      }
    } else {
      return defaultLang;
    }
  }

  getTripType() {
    const prefCookie = this.getCookies('trip_type');
    if (prefCookie) {
      if (prefCookie.length > 0) {
        const res = prefCookie.split('=');
        if (!res || !res.length || !res[1]) {
          return null;
        }
        return res[1].toLowerCase();
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getMcCacheKey() {
    const prefCookie = this.getCookies('mc_cache_key');
    if (prefCookie) {
      if (prefCookie.length > 0) {
        const res = prefCookie.split('=');
        if (!res || !res.length || !res[1]) {
          return null;
        }
        return res[1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getDeepLinkValue(cookieName) {
    const deepLinkSlimHeaderValue = this.getCookies(cookieName);
    if (deepLinkSlimHeaderValue) {
      if (deepLinkSlimHeaderValue.length > 0) {
        const res = deepLinkSlimHeaderValue.split('=');
        if (!res || !res.length || !res[1]) {
          return null;
        }
        return res[1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getDeepLinkVendorValue(cacheKeySuffix) {
    const deepLinkSlimHeaderValue = this.getCookies(
      'deepLinkVendor' + cacheKeySuffix
    );
    if (deepLinkSlimHeaderValue) {
      if (deepLinkSlimHeaderValue.length > 0) {
        const res = deepLinkSlimHeaderValue.split('=');
        if (!res || !res.length || !res[1]) {
          return null;
        }
        return res[1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  /**
   * Generate a unique ID (random + current timestamp)
   *
   * @returns {string} Value conformed by random string/numbers + current timestamp
   * @memberof CookieHelper
   */
  generateUID(): string {
    function generateNumber(): string {
      return Math.floor((1 + Math.random()) * 0x10000000)
        .toString(16)
        .substring(1);
    }

    return generateNumber() + '-' + Date.now() + '-' + generateNumber();
  }

  deleteCookie(cookieName) {
    const date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    // Set it
    document.cookie =
      cookieName +
      '=; expires=' +
      date.toUTCString() +
      this.applicationConfig.get('APP_COOKIE_DOMAIN');
  }

  setDeepLinkCookie(cookieName: any, cookieValue: any) {
    if (isPlatformBrowser(this.platformId)) {
      const cookiesLife = new Date();
      // set for 30 min
      cookiesLife.setTime(cookiesLife.getTime() + 30 * 60 * 1000);
      const expires = '; expires=' + cookiesLife.toUTCString();
      const cookieDomain = this.applicationConfig.get('APP_COOKIE_DOMAIN');
      const cookieDetails =
        cookieName + '=' + cookieValue + expires + cookieDomain;
      document.cookie = cookieDetails;
    }
  }
}
